/**
 * Returns the left position of the element relative to the document.
 */
export function elementLeft(element) {
    return element.getBoundingClientRect().left + window.pageXOffset;
}
/**
 * Returns the top position of the element relative to the document.
 */
export function elementTop(element) {
    return element.getBoundingClientRect().top + window.pageYOffset;
}
/**
 * Returns the horizontal centre of the element relative to the document, as a percentage
 */
export function percentElementHorzCentre(element) {
    return 100 * (elementLeft(element) + element.offsetWidth / 2) / window.innerWidth;
}
/**
 * Returns the vertical centre of the element relative to the document, as a percentage
 */
export function percentElementVertCentre(element) {
    return 100 * (elementTop(element) + element.offsetHeight / 2) / window.innerHeight;
}
